var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social-share",class:_vm.theme},[_c('div',[_vm._v("Share The Legacy")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social-icons"},[_c('a',{staticClass:"addthis_button_facebook"},[_c('i',{staticClass:"fab fa-facebook-square social-icon"})]),_c('a',{staticClass:"addthis_button_twitter"},[_c('i',{staticClass:"fab fa-twitter-square social-icon"})])])
}]

export { render, staticRenderFns }